import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addTrafficProfile: translate({ id: 'setup.traffic.addTrafficProfile' }),
    editTimeWindows: translate({ id: 'setup.traffic.editTimeWindows' }),
  }))

  return api
}
